export default "__VITE_ASSET__C7t5jNAy__"